import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import styles from './confWarehouse.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton'
import GoDown from './goDown/Item';
import Location from './location/Item'
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import {connect} from 'react-redux'
import { v4 as uuidv4 } from 'uuid';

const ConfWareHouse = (props) => {
    const [formData,setFormData] = React.useState({
        name: "",
        contactNum:"",
        warehouseLocation: "",
        address: "",
        warehouseId: ""
    });
    
    const [err,setErr] = React.useState({name: false,contactNum:false,warehouseLocation: false,address: false});
    const [locErr,setLocErr] = React.useState([{name: false,goDown: false}]);
    const [goErr,setGoErr] = React.useState([{name: false}]);

    const [goDown,setGoDown] = React.useState([
        {
            name: "",
            uniqueCode: uuidv4(),
        }
    ]);
    const [location,setLocation] = React.useState([
        {
            name: "",
            uniqueCode: uuidv4(),
            godown: ""
        }
    ]);

    const [loading,setLoading] = React.useState(false)

    

    React.useEffect(() => {
        if(props.type == "EDIT") {
            setFormData({...formData,...props.warehouse,warehouseId: props.warehouse._id})
            setGoDown([...props.warehouse.godownDetails])

            let arr = [];
            props.warehouse.godownDetails.forEach(godown => {
                props.warehouse.location.forEach(location => {
                    if(location.godown && godown._id == location.godown._id) {
                        arr.push({
                            ...location,
                            godown: godown.name
                        });
                    }  
                })
            })
            setLocation([...arr])
        } 
    },[props.warehouse]);

    // GO DOWN
    const handleGoDownAdd = () => { 
        let arr = goDown;
        let err = goErr;

        err.push({
            name: false
        });
        arr.push({
            name: "",
            uniqueCode: uuidv4()
        });

        setGoErr([...err]);
        setGoDown([...arr]);
    }

    const handleGoDownDelete = (valIndex) => { 
        let arr = goDown;
        let err= goErr;     


        err = err.filter((val,index) => {
            return index != valIndex;
        })

        arr = arr.filter((val,index) => {
            return index != valIndex;
        })

        setGoErr([...err])
        setGoDown([...arr]);
    }

    const handleGoDownFormChange = (index,key,value) => {
        let arr = goDown;
        arr[index][key] = value;
        setGoDown([...arr]);
    }

    // LOCATIONS  
    const handleLocationAdd = () => { 
        let arr = location;
        let err = locErr;

        err.push({
            name: false,
            godown: false
        })
        arr.push({
            name: "",
            uniqueCode: uuidv4(),
            godown: ""
        });
        setLocErr([...err])
        setLocation([...arr]);
    }

    const handleLocationDelete = (valIndex) => {
        let err = locErr;
        let arr = location;
        arr = arr.filter((val,index) => {
            return index != valIndex;
        })
        err = err.filter((val,index) => {
            return index != valIndex;
        })
        setLocErr([...err])
        setLocation([...arr]);
    }

    const handleLocationFormChange = (index,key,value) => {
        let arr = location;
        arr[index][key] = value;
        setLocation([...arr]);
    }

    const validate = () => {
        let validData = true;
        let error = {name: false,contactNum:false,warehouseLocation: false,address: false}
        let lErr = Array(location.length).fill('').map(val => {
            return {name: false,godown: false}
        });
        let gErr = Array(goDown.length).fill('').map(val => {
            return {name: false}
        }); 

        setErr({...err,...error});
        setGoErr([...gErr])
        setLocErr([...lErr])

        Object.keys(error).map(key => {
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            } 
            if(key == "contactNum" && formData[key].toString().length != 10) {
                error[key] = "Enter Valid Phone Number";
                validData = false
            }
        })
        if(props.type == "EDIT") {
            location.forEach((val,index) => {
                if(val.name == "") {
                    lErr[index].name = "Field cannot be empty"
                    validData = false
                }
                if(val.godown == "") {
                    lErr[index].godown = "Field cannot be empty"
                    validData = false
                }
            })
    
            goDown.forEach((val,index) => {
                if(val.name == "") { 
                    gErr[index].name = "Field cannot be empty"
                    validData = false
                } 
            })

            setGoErr([...gErr])
            setLocErr([...lErr])
        }
        setErr({...error}); 

        return validData;
    }

    // ONSUBMIT

    const onSubmit = () => {
        if(validate()) {
            setLoading(true); 
            const url = props.type == "EDIT" ? "/editWarehouse" : "/addWarehouse"
            axios({
                method: "post",
                url: url,
                data: {
                    ...formData,
                    godownDetails: goDown,
                    location
                }
            })
            .then(res => {
                if(res.data.success) {
                    props.onDone()
                    setLoading(false);
                    props.setAlert("Succesfully Done")
                    setFormData({userId: props.user._id,name: "",contactNum:"",warehouseLocation: "",address: "",warehouseId: ""})
                    setLocation([{name: "",uniqueCode: "",godown: ""}])
                    setGoDown([{name: "",uniqueCode: "",}])
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
        }
    }
    let btnText = props.type == "EDIT" ? "Update WareHouse" : "Add WareHouse";

    return (  
        <Dialog open={props.open} onClose={props.onClose} maxWidth={'lg'} scroll={'paper'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <IconButton onClick={props.onClose}>
                            <CloseRoundedIcon   />
                        </IconButton>
                    </div> 

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Name"
                                value={formData.name}                                
                                onBlur={(e) => setFormData({...formData,name: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,name: e.target.value})}
                                error={err.name}
                                helperText={err.name}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Contact Number"
                                type="text"
                                value={formData.contactNum}
                                onBlur={(e) => setFormData({...formData,contactNum: e.target.value.replace(/\D/,'').trim()})}

                                onChange={(e) => {
                                    e.target.value.length <= 10 && setFormData({...formData,contactNum: e.target.value.replace(/\D/,'')})  
                                }}
                                error={err.contactNum}
                                helperText={err.contactNum}
                            /> 
                        </div>

                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Ware House Location"
                                value={formData.warehouseLocation} 
                                onBlur={(e) => setFormData({...formData,warehouseLocation: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,warehouseLocation: e.target.value})}


                                error={err.warehouseLocation}
                                helperText={err.warehouseLocation}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Address"
                                value={formData.address}
                                onBlur={(e) => setFormData({...formData,address: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,address: e.target.value})}

                                error={err.address}
                                helperText={err.address}
                            /> 
                        </div> 
                    </div>
                {props.type == "EDIT" &&
                <React.Fragment>
                    <div className={styles.header}>
                        <h2>GoDown</h2>
                        <IconButton onClick={handleGoDownAdd}>
                            <AddRoundedIcon />
                        </IconButton>
                    </div>

                    {goDown && goDown.map((val,index) => {
                        return (
                            <GoDown 
                                item={val} 
                                index={index} 
                                key={index} 
                                onDelete={() => handleGoDownDelete(index)}  
                                onNameChange={(val) => handleGoDownFormChange(index,"name",val)}
                                onCodeChange={(val) => handleGoDownFormChange(index,"uniqueCode",val)}   

                                error={goErr[index]}
                            /> 
                        ) 
                    })}
 
                    <div className={styles.header}>
                        <h2>Location</h2>
                        <IconButton onClick={handleLocationAdd}>
                            <AddRoundedIcon />
                        </IconButton>
                    </div>

                    {location && location.map((val,index) => {
                        return (
                            <Location 
                                item={val} 
                                index={index} 
                                key={index} 
                                goDown={goDown}
                                onDelete={() => handleLocationDelete(index)}  
                                onNameChange={(val) => handleLocationFormChange(index,"name",val)}
                                onGoDownChange={(val) => handleLocationFormChange(index,"godown",val)}
                                onCodeChange={(val) => handleLocationFormChange(index,"uniqueCode",val)}   

                                error={locErr[index]}
                            /> 
                        ) 
                    })}

                </React.Fragment>}


                <Divider />

                <div className={styles.footer}>
                    {loading 
                        ?
                    <Button variant="contained" color="secondary">
                        Loading....
                    </Button>
                        :
                    <Button variant="contained" color="secondary" onClick={onSubmit}>
                        {btnText}
                    </Button>}
                </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user
})
export default connect(mapStateToProps)(ConfWareHouse);

